/**
 * Logs out the user after 15 minutes of inactivity on focused authenticated pages.
 */
export default defineNuxtPlugin(() => {
  const route = useRoute()
  const { status } = useAuth()
  const { idle, reset: resetIdle } = useIdle(
    15 * 60 * 1000, // 15 minutes idle
    { listenForVisibilityChange: true },
  )

  const isAuthenticated = computed(() => status.value === 'authenticated')
  const isValidRoute = computed(() => route.meta.disableActivePageIdleTimeout !== true) // Manually disabled on call pages
  const shouldMonitorIdle = computed(() => isAuthenticated.value && isValidRoute.value)

  watch([idle, shouldMonitorIdle], ([isIdle, shouldMonitor]) => {
    if (!shouldMonitor) {
      resetIdle()
      return
    }

    if (isIdle) {
      navigateTo('/auth/logout')
    }
  }, { immediate: true })
})
